module.exports = __webpack_public_path__ + "2a9f1389.webp";